<p-dialog
    [contentStyle]="{ overflow: 'visible', 'max-height': '60vh', 'max-width': '55vw' }"
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    (onHide)="closeDia($event)"
    (onShow)="initialize()"
>
    <ng-template pTemplate="header">
        <span>{{'Action_Doc' | translate}} - </span>
        @switch (action) {
            @case ('addtextpdf') {
                <span>{{'AddTextPdf' | translate}}</span>
            }
            @case ('annot') {
                <span>{{'Annot' | translate}}</span>
            }
            @case ('graphsign') {
                <span>{{'Graphsign' | translate}}</span>
            }
            @case ('stamp') {
                <span>{{'Stamp' | translate}}</span>
            }
        }
    </ng-template>

    <div class="col-12 md:col-12 align">
        <span>{{'Cur_Doc' | translate}} {{ currentDoc }}</span>
        <div>{{'Page' | translate}} {{ numPage }}</div>
    </div>

    @switch (action) {
        @case ('addtextpdf') {
            <div class="col-12">
                <div>{{'Text' | translate}}</div>
                <textarea
                    [rows]="3"
                    [cols]="30"
                    [(ngModel)]="textPdfValue"
                    class="p-inputtext size_cent"
                    pInputTextarea
                >
                </textarea>
            </div>
            <div class="col-12">
                <p-colorPicker [(ngModel)]="currentColor" [inline]="true"></p-colorPicker>
            </div>
        }
        @case ('annot') {
            <div class="col-12">
                <span class="p-float-label size_cent">
                    <input
                        [(ngModel)]="titleNote"
                        value="titleNote"
                        class="p-inputtext size_cent"
                        pInputText
                        type="text"
                    />
                    <label>{{'Title' | translate}}</label>
                </span>
            </div>
            <div class="col-12">
                <div>{{'Text' | translate}}</div>
                <textarea [(ngModel)]="textNote" rows="3" cols="57" pInputTextarea></textarea>
            </div>
            <div class="col-12 grid">
                <div class="col-6">
                    <p-dropdown [options]="listNote" [(ngModel)]="noteSelect"> </p-dropdown>
                </div>
                <div class="col-6">
                    <p-dropdown [options]="listColor" [(ngModel)]="colorSelect"> </p-dropdown>
                </div>
            </div>
        }
        @case ('graphsign') {
            <div class="col-12">
                <div class="p-float-label size_cent">
                    <input [(ngModel)]="motiv" value="motiv" class="p-inputtext size_cent" pInputText type="text" />
                    <label>{{'Motif' | translate}}</label>
                </div>
            </div>
        }
        @case ('stamp') {
            <div class="col-12">
                @if (stamp.Variable === 'Ask') {
                    <div class="p-float-label size_cent">
                        <input [(ngModel)]="stampValue" value="stampValue" class="p-inputtext size_cent" pInputText type="text" />
                        <label>{{'Stamp_Cnt' | translate}}</label>
                    </div>                    
                }@else {                    
                    <div class="p-float-label size_cent">
                        <div>{{'Stamp_Cnt' | translate}} : {{ stampValue }}</div>
                    </div>                
                }
            </div>
        }
    }

    <div class="col-12 md:col-12 align-right">
        <button class="margin p-button-primary p-button-outlined" pButton type="button" (click)="visible = false" label="{{'Cancel' | translate}}"></button>
        <button class="margin" pButton type="button" (click)="onClickAppy()" label="{{'Apply' | translate}}"></button>
    </div>
</p-dialog>

